import React from 'react';
import styled from 'styled-components';
import { Navbar } from '../components/Navbar';
import { Call } from '../components/Call';
import { Category } from '../components/Category';
import { Footer } from '../components/Footer';
import { menuItems } from '../data';

export const Menu = () => {
  return (
    <>
    <Navbar />
    <Container>
        <Call />
        <h1 className='menu-header'>Menu</h1>
        {menuItems.map(item => {
            return <Category key={item.id} id={item.id} name={item.name} />
        })}
        <Footer />
    </Container>
    </>
  )
}

const Container = styled.div`
    background-color: rgba(0,0,0,.8);
    max-width: 1035px;
    margin: auto;
    padding-top: 125px;

    h1.menu-header{
        color: #fff;
        font-family: "Roboto", sans-serif;
        font-size: 1.55rem;
        text-align: center;
        margin-top: 3rem;
    }
`;
